import { HFlow, Omit, Text, VFlow } from 'bold-ui'
import { SelectField, SelectFieldProps } from 'components/form/final-form'
import { HLabel } from 'components/HLabel'
import { CiapSelectFieldDocument } from 'graphql/hooks.generated'
import {
  CiapCapituloEnum,
  CiapSelectFieldQuery,
  CiapSelectFieldQueryVariables,
  SexoEnum,
} from 'graphql/types.generated'
import React from 'react'

import { DEFAULT_SELECT_SIZE, useAsyncQuerySelect } from '../useAsyncQuerySelect'

export type CiapSelectFieldModel = CiapSelectFieldQuery['ciaps']['content'][0]

export interface CiapSelectFieldProps extends Omit<SelectFieldProps<CiapSelectFieldModel>, 'items' | 'itemToString'> {
  sexo?: SexoEnum
  capitulosIncluidos?: CiapCapituloEnum[]
  capitulosExcluidos?: CiapCapituloEnum[]
  excluirCIAPsDAB?: boolean
}

export function CiapSelectField(props: CiapSelectFieldProps) {
  const { sexo, capitulosIncluidos, capitulosExcluidos, excluirCIAPsDAB, ...rest } = props
  const { ...asyncProps } = useAsyncQuerySelect<
    CiapSelectFieldModel,
    CiapSelectFieldQuery,
    CiapSelectFieldQueryVariables
  >({
    query: CiapSelectFieldDocument,
    extractItems: (data) => data?.ciaps?.content,
    variables: (inputQuery: string): CiapSelectFieldQueryVariables => ({
      input: {
        query: inputQuery,
        pageParams: {
          size: DEFAULT_SELECT_SIZE,
        },
        sexo,
        capitulosIncluidos,
        capitulosExcluidos,
        excluirCIAPsDAB,
      },
    }),
  })

  const itemToString = (item: CiapSelectFieldModel) => item && `${item.nome} - ${item.codigo}`

  const renderItem = (item: CiapSelectFieldModel) => (
    <VFlow vSpacing={0}>
      <Text fontWeight='bold'>{item.nome}</Text>
      <HFlow hSpacing={0.5}>
        <Text fontWeight='bold'>Código</Text>
        {item.codigo}
      </HFlow>
      {item.inclui && <HLabel title='Inclui:'>{item.inclui}</HLabel>}
      {item.exclui && <HLabel title='Exclui:'>{item.exclui}</HLabel>}
    </VFlow>
  )

  return (
    <SelectField<CiapSelectFieldModel> itemToString={itemToString} renderItem={renderItem} {...asyncProps} {...rest} />
  )
}
